import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faMessage,
  faEnvelope,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import faq from "../assets/new-images/faq.png";
import { accordionData } from "../data/dataTwo";
import { Link } from "react-router-dom";

const Contact = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      <Helmet>
        {/* Helmet Title is going from here  */}
        <title>How can we help? | Simplifyte</title>

        {/* Open Graph meta */}
        <meta property="og:title" content="Contact Us | Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="Get in touch with our sales and support teams for demos, onboarding support, or product questions."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/contact" />

        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte contact, contact Simplifyte, customer support, sales inquiry, demo request, onboarding support"
        />
      </Helmet>
      <HeaderMenu />
      <section className="contact-page md:py-24 py-36 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className=" mb-95 ">
                <div className="text-center main-top-div">
                  <h1 className="main-title_Contact">How can we help?</h1>
                  <p className="text-slate-400 main-para_Contact">
                    Get in touch with our sales and support teams for demos,
                    onboarding support, or product questions.
                  </p>
                </div>

                <div className="contact-boxes">
                  <div className="row-direction_Contact">
                    <div className="direction-columns">
                      {/* box-item  */}
                      <div className="sales-box group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <div className="box-header">
                          <p className="box-title-icon">
                            <FontAwesomeIcon icon={faEnvelope} />
                          </p>
                          <p className="box-title">Sales</p>
                        </div>
                        <div className="box-body">
                          <p className="box-content text-slate-400">
                            Talk to our sales team about plans, pricing, bulk
                            onboarding, or to request a demo.
                          </p>
                          <div className="box-btn">
                            <Link to="/contactsales" className="btn">
                              Talk to Sales{" "}
                              <span className="box-btn-icon">
                                <FontAwesomeIcon icon={faAngleRight} />
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="direction-columns">
                      <div className="help-box group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <div className="box-header">
                          <p className="box-title-icon">
                            <FontAwesomeIcon icon={faMessage} />
                          </p>
                          <p className="box-title">Help & support</p>
                        </div>
                        <div className="box-body">
                          <p className="box-content text-slate-400">
                            Have a question or found an issue? We’re here to
                            help—reach out anytime.
                          </p>
                          <div className="box-btn">
                            <Link to="/contactsupport" className="btn">
                              Contact Support{" "}
                              <span className="box-btn-icon">
                                <FontAwesomeIcon icon={faAngleRight} />
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="other-boxes">
                  <div className="row-direction">
                    <div className="direction-columns">
                      <div className="box-main-content join-comm">
                        <p className="content-title">Join the community</p>
                        <p className="content-desc text-slate-400">
                          Connect with fellow Simplifyte users, share tips, and
                          discover new workflows.
                        </p>
                        <a href="https://whatsapp.com/channel/0029VbCbtgwDDmFX89cBhV2o" target="_blank" rel="noopener noreferrer" className="content-link-btn">
                          Join Simplifyte{" "}
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </a>
                      </div>
                    </div>
                    <div className="direction-columns">
                      <div className="box-main-content general-comm">
                        <p className="content-title">General communication</p>
                        <p className="content-desc text-slate-400">
                          Have something else to ask? We’re just an email away.
                        </p>
                        <a
                          href="mailto:sales@simplifyte.com"
                          className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base
                           text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full 
                           after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600
                            hover:text-indigo-600 after:bg-indigo-600 duration-500"
                        >
                          sales@simplifyte.com
                        </a>
                      </div>
                    </div>
                    <div className="direction-columns">
                      <div className="box-main-content documentation">
                        <p className="content-title">Documentation</p>
                        <p className="content-desc text-slate-400">
                          Explore Simplifyte’s features, settings, and best
                          practices.
                        </p>
                        <a href="/docs" className="content-link-btn">
                          Read Docs{" "}
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden">
        <div className="container relative md:mt-12 mt-12">
          <div className="grid md:grid-cols-2 grid-cols-1 items-end">
            <div className="relative order-1 md:order-2">
              <img src={faq} className="rounded-lg" alt="Simplifyte" />
            </div>

            <div className="lg:me-8 order-2 md:order-1 mrgin-out">
              {/* font-size-same mb-4 md:text-3xl text-2xl lg:leading-normal leading-normal font-semibold c-margin */}
              <h2 className="contact_support_class">
                If you need help, <br /> we're here for you
              </h2>

              <div
                id="accordion-collapseone"
                data-accordion="collapse"
                className="mt-6 scrollable-faq"
              >
                {accordionData.slice(0, 11).map((item, index) => (
                  <div
                    key={index}
                    className="relative shadow dark:shadow-gray-800 rounded-xl overflow-hidden mt-4"
                  >
                    <h2
                      className="text-base font-semibold"
                      id="accordion-collapse-heading-1"
                    >
                      <button
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        className={`flex justify-between items-center p-5 w-full font-medium text-start ${
                          activeIndex === index
                            ? "bg-gray-50 dark:bg-slate-800 text-indigo-600"
                            : ""
                        }`}
                        data-accordion-target="#accordion-collapse-body-1"
                        aria-expanded="true"
                        aria-controls="accordion-collapse-body-1"
                      >
                        <span>{item.title}</span>
                        <svg
                          data-accordion-icon
                          className={`${
                            activeIndex === index ? "rotate-180" : "rotate-270"
                          } size-4 shrink-01`}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </button>
                    </h2>
                    {activeIndex === index && (
                      <div>
                        <div className="p-5">
                          <p className="text-slate-400 dark:text-gray-400">
                            {item.content}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomFooter />
    </>
  );
};

export default Contact;
